var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"single-pane"},[_c('div',{staticClass:"slot-container"},[_vm._t("default"),_c('div',{staticClass:"p-2"})],2)])}
var staticRenderFns = []

export { render, staticRenderFns }